import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import SearchIcon from "@mui/icons-material/Search";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { DateRangePicker } from "materialui-daterange-picker";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { Link } from "react-router-dom";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import LoadingComponent from "../loading"

import {
  Button,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import AppointmentStore from "../DataRepository/AppointmentStore";
import { format } from "date-fns";

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor: "#E7E7DB",
  borderRadius: "10px",
}));

const TimingButton = styled(Button)(({ theme }) => ({
  minWidth: "32px",
  height: "32px",
  backgroundColor: "#C0B7A7",
  color: "white",
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function PatientList() {
  const [open, setOpen] = useState(false);

  const { getPatientList, PatientList, isPatientListloading } = AppointmentStore();
  
  const [loading, setLoading] = useState(false);

  const [state, setState] = useState({
    startDate: dayjs().startOf("month").format("YYYY-MM-DD"),
    endDate: dayjs().endOf("month").format("YYYY-MM-DD"),
  });

  const [tabValue, setTabValue] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");

  const [filteredPatients, setFilteredPatients] = useState([]);

  const handleClickOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const setDateRange = (date) => {
    setState({ startDate: date.startDate, endDate: date.endDate });
  };

  useEffect(() => {
    getPatientList(
      dayjs(state.startDate).format("YYYY-MM-DD"),
      dayjs(state.endDate).format("YYYY-MM-DD")
    );
  }, [open]);

  useEffect(() => {
    let filtered = PatientList;

    if (tabValue === 1) {
     
      const repeatedPatientIds = PatientList.reduce((acc, patient) => {
        acc[patient.patient_id] = (acc[patient.patient_id] || 0) + 1;
        return acc;
      }, {});
      filtered = PatientList.filter(
        (patient) => repeatedPatientIds[patient.patient_id] > 1
      );
    } else if (tabValue === 2) {
      const uniquePatientIds = PatientList.reduce((acc, patient) => {
        acc[patient.patient_id] = (acc[patient.patient_id] || 0) + 1;
        return acc;
      }, {});
      filtered = PatientList.filter(
        (patient) => uniquePatientIds[patient.patient_id] === 1
      );
    }

    if (searchTerm) {
      const lowerSearchTerm = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (patient) =>
          patient.patient_name.toLowerCase().includes(lowerSearchTerm) ||
          patient.patient_id.toString().includes(lowerSearchTerm) ||
          patient.Appointment_id.toString().includes(lowerSearchTerm)
      );
    }

    setFilteredPatients(filtered);
  }, [PatientList, tabValue, searchTerm]);

  return (
    <div className="m-5">
      {loading && <LoadingComponent loading={AppointmentStore} />}
      <div className="flex items-center justify-between gap-4 PatientlistTitle">
        {/* Patient List Title */}
        <div className="PatientlistTitletext whitespace-nowrap">
          {PatientList.length > 0 ? (
            <p>Patient List ({PatientList.length})</p>
          ) : (
            <p>Patient List</p>
          )}
        </div>

        {/* Search Input */}
        <div className="Patientlistinput flex-grow relative">
          <input
            placeholder="Search"
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
            style={{ paddingRight: "40px" }} // Space for the icon
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <span className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500">
            <SearchIcon />
          </span>
        </div>
        <Button
          className="flex items-center border !border-amber-600 !text-amber-600 rounded px-4 py-2 text-sm font-medium"
          onClick={handleClickOpen}
        >
          <DateRangeIcon className="mr-2" /> Sort by Date
        </Button>
      </div>

      <div className="flex items-center justify-center">
        <Tabs
          value={tabValue}
          onChange={(e, newValue) => setTabValue(newValue)}
          textColor="inherit" // Use "inherit" instead of a hex value
          indicatorColor="primary" // Use "primary" or customize via sx
          sx={{
            margin: "20px 0",
            "& .MuiTabs-indicator": {
              backgroundColor: "#da6e0b", // Custom indicator color
            },
            "& .MuiTab-root": {
              color: "#3B362A", // Default text color
              fontWeight: 500,
              fontFamily: "'Poppins', sans-serif",
            },
            "& .Mui-selected": {
              color: "#da6e0b !important", // Text color of active tab
            },
          }}
        >
          <Tab label="All" />
          <Tab label="Follow-Up" />
          <Tab label="New" />
        </Tabs>
      </div>

      <div className="list-appointments">
        <TableContainer
          style={{ borderRadius: "8px" }}
          className="AppointmentTable"
        >
          <Table>
            <StyledTableHead>
              <TableRow>
                <TableCell className="tableheadtitle" align="center">
                  Date
                </TableCell>
                <TableCell className="tableheadtitle" align="center">
                  Timing
                </TableCell>
                <TableCell className="tableheadtitle">Patient Name</TableCell>
                <TableCell className="tableheadtitle" align="center">
                  Gender
                </TableCell>
                <TableCell className="tableheadtitle" align="center">
                  Age
                </TableCell>
                <TableCell className="tableheadtitle" align="center">
                  Mode of Consultation
                </TableCell>
                <TableCell className="tableheadtitle"></TableCell>
              </TableRow>
            </StyledTableHead>
            <TableBody>
              {filteredPatients.map((row, index) => (
                <TableRow key={index} className="TableRowContainer">
                  <TableCell align="center">
                    {row.appointment_date
                      ? format(new Date(row.appointment_date), "dd-MMM-yyyy")
                      : "N/A"}
                  </TableCell>
                  <TableCell align="center">{row.appointment_time}</TableCell>
                  <TableCell>
                    <TimingButton>{row?.patient_name?.charAt(0)}</TimingButton>
                    &nbsp; {row?.patient_name}
                  </TableCell>
                  <TableCell align="center">{row?.gender || ""}</TableCell>
                  <TableCell align="center">{row?.patient_age}</TableCell>
                  <TableCell align="center">
                    {row?.consultation_type} Consultation
                  </TableCell>
                  <TableCell align="right">
                    <Button
                      style={{
                        width: "100%",
                        textTransform: "none",
                        borderRadius: "0",
                        border: "1px solid #DA6E0B ",
                        color: "#DA6E0B",
                        boxSizing: "border-box",
                        borderRadius: "5px",
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        padding: "5px",
                      }}
                      component={Link}
                      to={`/Patient/${row.Appointment_id}`}
                    >
                      View Profile
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Select Date Range
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <DateRangePicker
            open={open}
            toggle={() => setOpen(!open)}
            onChange={setDateRange}
            initialDateRange={{
              startDate: state.startDate,
              endDate: state.endDate,
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Save Changes
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}

export default PatientList;
